module.exports = __webpack_public_path__ + "img/chinesecompany173.76ce3598.png";